module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"woocommerce_setup":"WooCommerce Setup"},"id":{"woocommerce_setup":"Pengaturan WooCommerce"}}')
  delete Component.options._Ctor
}
